import { type AgentSessionResponse } from '@air/server-sdk';

export type WorkspaceAgentSessionBucket = 'needs-response' | 'in-progress' | 'all-tasks' | 'archived';

export const classifyWorkspaceAgentSessionBucket = (session: AgentSessionResponse): WorkspaceAgentSessionBucket => {
  if (session.status === 'archived') {
    return 'archived';
  }

  if (session.status === 'inputRequested') {
    return 'needs-response';
  }

  if (session.status === 'processing') {
    return 'in-progress';
  }

  return 'all-tasks';
};
